import { useMutation } from "@apollo/client";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooProductSelector from "components/shared/OdooProductSelector";
import { ODOO_SAVE_PRODUCT } from "./graphql";

const LinkOdooProductMTView = ({ instance, product, hide }) => {
  const [saveProduct, saveProductRes] = useMutation(ODOO_SAVE_PRODUCT, {
    onCompleted() {
      Alert("success", "Product linked successfully");
      hide();
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: ["FETCH_ODOO_MT_PRODUCTS"],
    awaitRefetchQueries: true,
  });

  function linkProductHandler(product, odooProductId) {
    saveProduct({
      variables: {
        instance: "INC",
        odooProductId,
        xStudioMarkettimeProductId: product.recordID,
      },
    });
  }

  if (saveProductRes.loading) return <Spinner />;

  return (
    <OdooProductSelector
      instance={instance}
      initialSearchText={product.itemNumber}
      onSelect={(odooProductId) => linkProductHandler(product, odooProductId)}
    />
  );
};

export default LinkOdooProductMTView;
